function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import SvgIcon from './SvgIcon';
import classNames from 'classnames';
import { t } from '../i18n';
var defaultProps = {
  className: '',
  viewBox: '0 0 448 512'
};

function MenuIcon(props) {
  var classes = classNames(props.className, 'ds-c-icon--menu');
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    title: t('icons.menu')
  }, defaultProps, props, {
    className: classes
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"
  }));
}

export default MenuIcon;